const VAULT_STATE_SIZE = 2;
const ANCHOR_DISCRIMINATOR_SIZE = 8;

export function decodeVaultState(data) {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  const offset = bytes.length >= VAULT_STATE_SIZE + ANCHOR_DISCRIMINATOR_SIZE ? ANCHOR_DISCRIMINATOR_SIZE : 0;

  if (bytes.length < offset + VAULT_STATE_SIZE) {
    throw new Error('Invalid vault state account size.');
  }

  return {
    kind: bytes[offset],
    bump: bytes[offset + 1],
  };
}
